import PlaceService from '@/services/place.service'

const state = {
    readingStates: false,
    readingCities: false,
    states: {
        0: 'Todos' // db indexes start from 1
    },
    cities: {
        0: 'Todas' // db indexes start from 1
    }
}

const getters = {}

const actions = {
    read: async ({ commit }, args) => {
        let id = null
        if (args) id = args.id
        if (id) commit('startedReadingCities')
        else commit('startedReadingStates')
        try {
            let places = await PlaceService.read(id)
            if (id) commit('readCitiesSuccess', places)
            else commit('readStatesSuccess', places)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    }
}

const mutations = {
    startedReadingCities(state) {
        // reactivity hack (because of 'deep' object updates)
        state.readingCities = true
    },
    startedReadingStates(state) {
        // reactivity hack (because of 'deep' object updates)
        state.readingStates = true
    },
    readCitiesSuccess(state, cities) {
        state.cities = {}
        state.cities[0] = 'Todas'
        for (let city of cities) {
            state.cities[city.id] = city.name
        }
        state.readingCities = false
    },
    readStatesSuccess(state, states) {
        state.states = {}
        state.states[0] = 'Todos'
        for (let _state of states) {
            state.states[_state.id] = _state.name
        }
        state.readingStates = false
    }
}

const places = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default places
export { places }
